export default function Icon2_1() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="16.25" stroke="#F8200C" strokeWidth="2.5" />
            <path d="M10.5 11L11.2672 13.7328L14 14.5L11.2672 15.2672L10.5 18L9.73279 15.2672L7 14.5L9.73279 13.7328L10.5 11Z" fill="#F8200C" />
            <path d="M29.5 21L30.048 22.952L32 23.5L30.048 24.048L29.5 26L28.952 24.048L27 23.5L28.952 22.952L29.5 21Z" fill="#F8200C" />
            <path d="M16.8235 11L14 21L18.9412 21.7692L16.8235 31L26 19.4616L20.353 17.923L24.5882 11H16.8235Z" fill="#F8200C" />
            <line x1="8.29289" y1="30.9198" x2="30.9203" y2="8.29243" stroke="#F8200C" strokeWidth="2" />
        </svg>
    );
}
